import { gql } from '@apollo/client';

export const CREATE_RETURN = gql`
    mutation createReturn($returnInput: ReturnInput!) {
        createReturn(returnInput: $returnInput)
    }
`;
